export const freeBuildsPath = ({ workspaceSlug }: { workspaceSlug: string }) =>
  `/workspaces/${workspaceSlug}/free_builds`;
